interface EncryptedData {
  encryptedStr: string;
  key: string;
  iv: string;
}

const getRandomBytes = async (length: number): Promise<Uint8Array> => {
  return window.crypto.getRandomValues(new Uint8Array(length));
};

export async function encryptWithAES(credentials: string): Promise<EncryptedData> {
  const key = await getRandomBytes(32);
  const iv = await getRandomBytes(12);

  const cryptoKey = await window.crypto.subtle.importKey("raw", key, { name: "AES-GCM" }, false, [
    "encrypt",
  ]);

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
      tagLength: 128,
    },
    cryptoKey,
    new TextEncoder().encode(credentials)
  );

  return {
    encryptedStr: btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer))),
    key: btoa(String.fromCharCode(...key)),
    iv: btoa(String.fromCharCode(...iv)),
  };
}
